(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ad-cotton-candy-drop"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.ad-cc__pause-btn');
      if (!btn) return;
      var section = btn.closest('.ad-cc');
      if (!section) return;
      var video = section.querySelector('.ad-cc__hero-video');
      if (!video) return;
      var pauseIcon = btn.querySelector('.ad-cc__pause-icon');
      var playIcon = btn.querySelector('.ad-cc__play-icon');
      if (video.paused) {
        video.play();
        if (pauseIcon) pauseIcon.style.display = '';
        if (playIcon) playIcon.style.display = 'none';
      } else {
        video.pause();
        if (pauseIcon) pauseIcon.style.display = 'none';
        if (playIcon) playIcon.style.display = '';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["art-director-home"] && !Shopify.designMode) return;
  try {
    
  if (!window.__artDirectorHomeBound) {
    window.__artDirectorHomeBound = true;

    // Product rail scroll
    document.addEventListener('click', function (event) {
      const button = event.target.closest('[data-ad-scroll]');
      if (!button) return;
      const rail = document.getElementById(button.getAttribute('aria-controls'));
      if (!rail) return;
      const direction = Number(button.dataset.adScroll || 1);
      rail.scrollBy({ left: direction * Math.max(280, rail.clientWidth * 0.82), behavior: 'smooth' });
    });

    // Video pause/play toggle. Resolve the clicked hero so duplicated
    // sections in the Theme Editor do not control each other.
    document.addEventListener('click', function (event) {
      const btn = event.target.closest('.ad-video-pause-btn');
      if (!btn) return;
      const hero = btn.closest('.ad-video-hero');
      if (!hero) return;
      const video = hero.querySelector('.ad-video-hero__video');
      if (!video) return;
      const pauseIcon = btn.querySelector('.ad-pause-icon');
      const playIcon = btn.querySelector('.ad-play-icon');
      if (video.paused) {
        video.play().catch(function () {});
        if (pauseIcon) pauseIcon.style.display = '';
        if (playIcon) playIcon.style.display = 'none';
        btn.setAttribute('aria-label', 'Pause video');
      } else {
        video.pause();
        if (pauseIcon) pauseIcon.style.display = 'none';
        if (playIcon) playIcon.style.display = '';
        btn.setAttribute('aria-label', 'Play video');
      }
    });

      // Keep the campaign walk deliberate without changing the source video.
        document.querySelectorAll('.ad-video-hero__video').forEach(function (video) {
            var rate = 0.8;
                video.defaultPlaybackRate = rate;
                    video.playbackRate = rate;
                        video.addEventListener('loadedmetadata', function () {
                              video.defaultPlaybackRate = rate;
                                    video.playbackRate = rate;
                                        }, { once: true });
                                          });
                                          // Frequency line draw on scroll
    document.querySelectorAll('.ad-frequency-line').forEach(function(freqLine) {
      const freqObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting) { freqLine.classList.add('ad-frequency-line--visible'); freqObs.unobserve(freqLine); }
        });
      }, { threshold: 0.5 });
      freqObs.observe(freqLine);
    });

    // Manifesto reveal on scroll
    document.querySelectorAll('.ad-manifesto').forEach(function(manifesto) {
      const mObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting) { manifesto.classList.add('ad-manifesto--visible'); mObs.unobserve(manifesto); }
        });
      }, { threshold: 0.25 });
      mObs.observe(manifesto);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
